module.exports = "static/assets/8505df165b778979791da5caaee96fea.png";